import { Box, Typography } from '@mui/material';
import Markdown from 'react-markdown';

class SummaryFormatter {
  markdownDisplayer(markdown: string) {
    return (
      <Markdown
        children={markdown}
        components={{
          p: ({ children }) => (
            <Box
              component="p"
              sx={{
                fontSize: '0.875rem',
                fontWeight: 400,
                lineHeight: 1.25,
                margin: 0,
                '& + &': { mt: 1 },
              }}
            >
              {children}
            </Box>
          ),
          li: ({ children }) => (
            <Typography component="li" variant="bodyMedium">
              {children}
            </Typography>
          ),
          h1: ({ children }) => (
            <Typography
              component="div"
              variant="titleLarge"
              sx={{ mt: 2, mb: 1 }}
            >
              {children}
            </Typography>
          ),
          h2: ({ children }) => (
            <Typography
              component="div"
              variant="titleMedium"
              sx={{ mt: 2, mb: 1 }}
            >
              {children}
            </Typography>
          ),
          h3: ({ children }) => (
            <Typography
              component="div"
              variant="titleMedium"
              sx={{ mt: 1.5, mb: 0.5 }}
            >
              {children}
            </Typography>
          ),
          h4: ({ children }) => (
            <Typography
              component="div"
              variant="titleSmall"
              sx={{ mt: 1, mb: 0.5 }}
            >
              {children}
            </Typography>
          ),
          h5: ({ children }) => (
            <Typography
              component="div"
              variant="titleSmall"
              sx={{ mt: 0.5, mb: 0.5 }}
            >
              {children}
            </Typography>
          ),
          h6: ({ children }) => (
            <Typography
              component="div"
              variant="titleSmall"
              sx={{ mt: 0.5, mb: 0.5 }}
            >
              {children}
            </Typography>
          ),
        }}
      />
    );
  }

  markdownDisplayerCompact(markdown: string) {
    return (
      <Markdown
        children={markdown}
        components={{
          p: ({ children }) => (
            <Box
              component="p"
              sx={{
                fontSize: '0.875rem',
                fontWeight: 400,
                lineHeight: 1.25,
                margin: 0,
                '& + &': { mt: 1 },
              }}
            >
              {children}
            </Box>
          ),
          li: ({ children }) => (
            <Typography component="li" variant="bodyMedium">
              {children}
            </Typography>
          ),
          hr: () => null,
          h1: ({ children }) => (
            <Typography
              component="div"
              variant="titleLarge"
              sx={{
                mt: 2,
                mb: 0.25,
                fontWeight: 700,
                textDecoration: 'none',
              }}
            >
              {children}
            </Typography>
          ),
          h2: ({ children }) => (
            <Typography
              component="div"
              variant="titleMedium"
              sx={{
                mt: 2,
                mb: 0.25,
                fontWeight: 700,
                textDecoration: 'none',
              }}
            >
              {children}
            </Typography>
          ),
          h3: ({ children }) => (
            <Typography
              component="div"
              variant="titleMedium"
              sx={{
                mt: 1.5,
                mb: 0.25,
                fontWeight: 700,
                textDecoration: 'none',
              }}
            >
              {children}
            </Typography>
          ),
          h4: ({ children }) => (
            <Typography
              component="div"
              variant="titleSmall"
              sx={{
                mt: 1,
                mb: 0.25,
                fontWeight: 700,
                textDecoration: 'none',
              }}
            >
              {children}
            </Typography>
          ),
          h5: ({ children }) => (
            <Typography
              component="div"
              variant="titleSmall"
              sx={{
                mt: 0.5,
                mb: 0.25,
                fontWeight: 700,
                textDecoration: 'none',
              }}
            >
              {children}
            </Typography>
          ),
          h6: ({ children }) => (
            <Typography
              component="div"
              variant="titleSmall"
              sx={{
                mt: 0.5,
                mb: 0.25,
                fontWeight: 700,
                textDecoration: 'none',
              }}
            >
              {children}
            </Typography>
          ),
        }}
      />
    );
  }
}

export const summaryFormatter = new SummaryFormatter();
